export default __webpack_public_path__ + "static/media/eb-ultra-pro-2.2e818edf.png";